import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { CalendarCancelledIcon } from "../../../assets/icons";
import { useState } from "react";

const QuizNotOk = () => {
  const classes = useStyles();

  const [isChecked, setIsChecked] = useState(false);

  return (
    <Box className={classes.container}>
      <Box className={classes.contentContainer}>
        <img src={CalendarCancelledIcon} alt="cancelled-calendar" draggable="false" />
        <Typography variant="h2">Você não poderá realizar o agendamento.</Typography>
        <Typography>
          De acordo com as informações fornecidas no questionário. Precisamos que você responda o formulário disponibilizado pela equipe médica da PepsiCo.
        </Typography>
        <Typography>Acesse nossas orientações <a href="/">disponíveis aqui</a> ou <a href="/">assista ao vídeo</a>.</Typography>
        <FormControlLabel
          control={
            <Checkbox
              className={classes.checkBox}
              checked={isChecked}
              onChange={(event) => setIsChecked(event.target.checked)}
              name="terms"
            />
          }
          label="Declaro que estou ciente da necessidade de responder o formulário de saúde da equipe médica PepsiCo."
          className={classes.formLabel}
        />
      </Box>
      <Button
        component={Link}
        to='/'
        disabled={!isChecked}
        className={classes.button}
      >
        Voltar para o Início
      </Button>
    </Box>
  );
}

export default QuizNotOk;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',

      [theme.breakpoints.up('sm')]: {
        paddingBottom: theme.spacing(4),
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: theme.spacing(4),
        minHeight: '40vh',
        justifyContent: 'center',
      },
    },

    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 132,
        filter: 'drop-shadow(0px 5px 10px #21212133)'
      },

      '& h2': {
        maxWidth: '72vw',
        margin: theme.spacing(4, 0, 2),
        color: theme.palette.error.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center'
      },

      '& p': {
        marginTop: theme.spacing(1),
        maxWidth: '90vw',
        textAlign: 'center',

        [theme.breakpoints.up('sm')]: {
          margin: theme.spacing(1, 0, 6),
          width: "71%",
        },
        [theme.breakpoints.up('lg')]: {
          width: "65%",
        },

        '& a': {
          textDecoration: "underline",
        }
      }
    },
    formLabel: {
      marginTop: theme.spacing(2),
      color: theme.palette.primary.light,
      maxWidth: '80vw',
    },
    checkBox: {
      "&&": {
        color: theme.palette.primary.light,
        // '&$checked': {
        //   color: theme.palette.primary.light,
        // },
      }
    },

    button: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(0.5, 2.5),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "initial",
      border: `1px solid ${theme.palette.text.secondary}`,
      borderRadius: 17,
    },
  }))